import { createFileRoute } from '@tanstack/react-router'
import { BallotPage } from '../components/ballots/BallotPage'

// The co-owner's remote ballot (spec 2026-10-05-08 §6). Outside routes/$org,
// so it inherits no auth guard: the link token in the URL fragment is the
// whole authorization.
export const Route = createFileRoute('/v/$orgCode')({
  component: BallotRoute,
})

function BallotRoute() {
  const { orgCode } = Route.useParams()
  return <BallotPage orgCode={orgCode} />
}
